'use strict';
module.exports = require('./Textarea.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/textarea/index.js
// module id = 19
// module chunks = 1